import { cssVar } from './cssVar'

export const fontTokens = {
  sans: cssVar('--app-font-sans'),
  display: cssVar('--app-font-sans'),
  serif: cssVar('--app-font-sans'),
  mono: cssVar('--app-font-sans'),
  scaleOffset: cssVar('--app-font-scale-offset'),
  sizeLabel: cssVar('--app-font-size-label'),
  sizeBody: cssVar('--app-font-size-body'),
  sizeTitle: cssVar('--app-font-size-title'),
  sizeDisplay: cssVar('--app-font-size-display'),
  sizeNano: cssVar('--app-font-size-label'),
  sizeSectionTitle: cssVar('--app-font-size-label'),
  sizeXs: cssVar('--app-font-size-label'),
  sizeSm: cssVar('--app-font-size-label'),
  sizeCaption: cssVar('--app-font-size-body'),
  sizeMd: cssVar('--app-font-size-body'),
  sizeBodyLg: cssVar('--app-font-size-title'),
  sizeLg: cssVar('--app-font-size-title'),
  sizeDisplayLg: cssVar('--app-font-size-display'),
  weightRegular: cssVar('--app-font-weight-regular'),
  weightMedium: cssVar('--app-font-weight-medium'),
  lineHeightBase: cssVar('--app-line-height'),
  lineHeightTight: cssVar('--app-line-height'),
  leftNavButton: {
    size: cssVar('--app-font-size-body'),
    weight: cssVar('--app-font-weight-medium'),
    lineHeight: cssVar('--app-line-height'),
  },
  thought: {
    size: cssVar('--app-font-size-label'),
    lineHeight: cssVar('--app-line-height'),
    weightRegular: cssVar('--app-font-weight-regular'),
    weightMedium: cssVar('--app-font-weight-medium'),
  },
  agentResult: {
    size: cssVar('--app-font-size-body'),
    weight: cssVar('--app-font-weight-regular'),
    weightMedium: cssVar('--app-font-weight-medium'),
    titleSize: cssVar('--app-font-size-title'),
    lineHeight: cssVar('--app-line-height'),
  },
  agentThinking: cssVar('--app-font-size-body'),
  agentBody: cssVar('--app-font-size-body'),
  agentEmphasis: cssVar('--app-font-size-body'),
  agentTitle: cssVar('--app-font-size-title'),
  userBubble: { size: cssVar('--app-font-size-body'), lineHeight: cssVar('--app-line-height') },
}
